import { getAuthenticationToken } from '../../../../corelogic/state/authentication/authentication.selector';
import { retrieveSeasons } from '../../../../corelogic/state/season/season.action';
import { store } from '../../../../corelogic/state/store';

export const SeasonService = {
  retrieveSeasons: () => {
    const token = getAuthenticationToken(store.getState());
    if (!token) {
      console.warn('SeasonService: No authentication token found');
      return;
    }

    store.dispatch(retrieveSeasons({ retry: 0, token: token }));
  },
};
